import {
  DEFAULT_TIME_WHEEL_PICKER_VALUE,
  TimeWheelPickerValue
} from 'constants/time-wheel-picker';

export const getTimeWheelPickerInitialValue = (
  initialValue?: string
): TimeWheelPickerValue => {
  if (!initialValue || typeof initialValue !== 'string') {
    return DEFAULT_TIME_WHEEL_PICKER_VALUE;
  }

  const [hourStr, minuteStr] = initialValue.trim().split(':');
  const hour24 = Number(hourStr);
  const minute = Number(minuteStr);

  if (
    Number.isNaN(hour24) ||
    Number.isNaN(minute) ||
    hour24 < 0 ||
    hour24 > 23 ||
    minute < 0 ||
    minute > 59
  ) {
    return DEFAULT_TIME_WHEEL_PICKER_VALUE;
  }

  const period = hour24 >= 12 ? 'PM' : 'AM';
  const hour12 = hour24 % 12 === 0 ? 12 : hour24 % 12;

  return {
    hour: String(hour12).padStart(2, '0'),
    minute: String(minute).padStart(2, '0'),
    period
  };
};